<template>
  <div class="input-adapter-show-tip">
    <div class="text"
      v-html="value"></div>
  </div>
</template>

<script>
export default {
  name: 'InputAdapterShowTip',

  props: {
    title: {},
    value: {},
    cbs: {},
    idx: ''
  },

  created () {
    this.cbs && this.cbs.setNoActionsControl()
  },

  mounted () {
    if (this.idx === 0) {
      setTimeout(() => {
        this.cbs.tryNextCardItem()
      }, 1000)
    }
    // TODO: improve
    if (this.cbs) {
      this.cbs.onCardActive(() => {
        setTimeout(() => {
          if (this.cbs) {
            this.cbs.tryNextCardItem()
          }
        }, 4000)
      })
    }
  }
}
</script>

<style lang="scss">
.input-adapter-show-tip {
  .text {
    font-size: 12px;
  }
}
</style>
